export enum GraphIconType {
  Additional = "additional_mailing",
  ProxyMessage = "proxy_message",
}

export interface IGraphDotStat {
  shares?: number;
  customers?: number;
  range?: string;
  type: GraphIconType;
  name: string;
  fullDate?: string;
}

export interface IGraphDotStats {
  [key: string]: IGraphDotStat;
}

export const GRAPH_DATE_FORMAT = "MMM D";
